module.exports = __webpack_public_path__ + "static/cad-designs28-812d8711625d15029676676655786fdc.png";